module.exports = __webpack_public_path__ + "img/orange-search-icon.8d30d946.svg";